import { useState } from "react";
import { reportBug } from "../services/reportBug";

export const useReportBug = () => {
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const reportTheBug = async (bugsDetailes) => {
    setIsLoading(true);
    setError(false);

    try {
      const response = await reportBug(bugsDetailes);
      setIsLoading(false);
      if (response.status === 200) {
        setError(true);
        return "su" || "An error occurred while reporting the bug.";
      }
      return response;
    } catch (error) {
      setIsLoading(false);
      setError(true);
      return "Something went wrong while reporting the bug.";
    }
  };

  return { reportTheBug, isLoading, error };
};
